<ng-container *ngrxLet="modalData.component$ as component">
	<div *nzModalTitle>
		<span class="text-base md:text-lg lg:text-lg">
			{{ modalData.title }}
		</span>
		@if (modalData.subTitle) {
			@if (isArray(modalData.subTitle)) {
				<fms-chip>
					@for (
						elem of modalData.subTitle;
						track elem;
						let last = $last
					) {
						{{ elem }}
						@if (!last) {
							<nz-divider nzType="vertical" />
						}
					}
				</fms-chip>
			} @else {
				<fms-chip>{{ modalData.subTitle }}</fms-chip>
			}
		}
	</div>
	<div class="p-4">
		@if (modalData.audioUrl) {
			<audio
				[src]="modalData.audioUrl"
				preload
				controls
				class="w-full"
			></audio>
		}
	</div>
	@if (component?.aboveFoldContent) {
		<div class="p-4">
			<div class="text-base font-bold md:text-lg">
				{{
					modalData.textContentTitle
						? modalData.textContentTitle
						: 'Om'
				}}
			</div>
			<div>
				<p>{{ component.aboveFoldContent }}</p>
				@if (showBelowFold) {
					<p>{{ component?.belowFoldContent }}</p>
				}
				@if (component?.belowFoldContent) {
					<fms-button (click)="toggleBelowFoldContent()">
						{{ showBelowFold ? 'Læs mindre' : 'Læs mere' }}
					</fms-button>
				}
			</div>
		</div>
	}
	<div *nzModalFooter class="h-12">
		<fms-toggle-favorite-button
			class="float-left"
			mode="button"
			[componentId]="component.id"
			[actionId]="component?.favoriteAction?.id"
		/>
		@if (modalData.relatedCourseSessionId !== null) {
			<fms-button
				class="float-left ml-2"
				(click)="goToRelatedCourseSession()"
			>
				<span class="mr-2">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						class="h-6 w-6"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
						/>
					</svg>
				</span>
				Gå til temadag
			</fms-button>
		}
		<fms-button class="float-right" (click)="closeModal()">
			<span class="mr-2">
				<svg
					class="h-6 opacity-50"
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M5 13l4 4L19 7"
					/>
				</svg>
			</span>
			Luk
		</fms-button>
	</div>
</ng-container>
